export default __webpack_public_path__ + "static/media/ctt-logo-icon.bea16eb1.svg";